<template>
  <b-overlay :show="loading" opacity="0.8">
    <validation-observer ref="form_ref" #default="{ invalid }">
      <b-card class="rounded-lg">
        <template #header>
          <div class="d-flex justify-content-between align-items-center w-100 pb-1" style="border-bottom: 2px solid rgb(238, 238, 238);">
            <h4 class="text-dark m-0">
              Dietician's Advice
            </h4>

            <b-dropdown variant="link" class="p-0" no-caret :right="$store.state.appConfig.isRTL" dropleft>
              <b-dropdown-item 
                v-if="can('consultations:CanUpdate') && currentUserProfession === 'dietician'" 
                :disabled="invalid || dietary_advice === consultationData.dietary_advice" 
                @click="onUpdate"
              >
                <feather-icon class="" icon="EditIcon" />
                <span class="align-middle ml-50">Update</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>

        <validation-observer #default="{ handleSubmit }" ref="update_modal_form">
          <b-form @submit.prevent="handleSubmit(onUpdate)">
            <div class="no-body">
              <validation-provider #default="validationContext" name="" rules="">
                <b-form-group label="">
                  <b-form-textarea
                    id="history"
                    v-model="dietary_advice"
                    rows="15"
                    :disabled="disableForm"
                    :state="getValidationState(validationContext)"
                  />

                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </div>

            <b-button 
              v-if="can('consultations:CanUpdate') && currentUserProfession==='dietician'" 
              class="float-right" 
              variant="outline-primary" 
              :disabled="invalid || dietary_advice === consultationData.dietary_advice" @click="onUpdate"
            >
              Update
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
    </validation-observer>
  </b-overlay>
</template>

<script>
import {
  BRow,
  BCol,
  BImg,
  BCard,
  BForm,
  BBadge,
  BAlert,
  BButton,
  BAvatar,
  BOverlay,
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BFormTextarea,
  BFormInvalidFeedback,
} from 'bootstrap-vue'

import { get } from 'lodash';
import { heightTransition } from '@core/mixins/ui/transition';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BBadge,
    BAlert,
    BAvatar,
    BButton,
    BOverlay,
    BDropdown,
    BFormGroup,
    BFormTextarea,
    BDropdownItem,
    BFormInvalidFeedback,

    // validations
    ValidationProvider,
    ValidationObserver
  },
  mixins: [heightTransition],
  props: {
    consultationData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      dietary_advice: this.consultationData.dietary_advice
    }
  },
  computed: {
    disableForm(){
      return !this.can(`consultations:CanUpdate`)
    },
  },
  methods: {
    async onUpdate(){
      try {
        this.loading = true;
        this.errorMessage = "";

        const success = await this.$refs.form_ref.validate();
        if (!success){
          return;
        }

        if (!this.can(`consultations:CanUpdate`)) {
          return
        }

        await this.useJwt().mainService.consultations.update(this.consultationData.id, {
          dietary_advice: this.dietary_advice
        });

        this.$emit('refresh')

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            variant: 'success',
            icon: 'CheckCircleIcon',
            text: `Dietician's advice updated successfully`
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
  }
}
</script>

<style scoped>
.profile-highlight {
  font-size: 18px !important;
}
.profile-highlight-title {
  font-size: 16px !important;
  color: lightgray;
  font-weight: normal;
}

.patient-name {
  font-size: 25px;
}
</style>
